<div
  *ngIf="customStyle$ | async as customStyle"
  class="header-movie-menu-styles"
  [innerHTML]="customStyle | safe: 'html'"
></div>

<footer
  id="footer-container"
  [attr.data-custom-template]="customTemplate ? true : false"
  [attr.data-sign-up]="emailSubscriptionSignupEnabled"
  [attr.data-legacy-sign-up]="channel?.commsConsumerSignup"
>
  <!-- There is something wrong with this implementation of custom template not working for some reason on widget -->
  <ng-container *ngTemplateOutlet="customTemplate; context: listOfVariables"></ng-container>
  <ng-container *ngIf="!customTemplate">
    <ng-container *ngIf="emailSubscriptionSignupEnabled">
      <div id="footer-subscribe-form">
        <ush-showtime-streaming-subscribe [type]="'all'"></ush-showtime-streaming-subscribe>
      </div>
    </ng-container>
    <div class="footer-wrapper" [ngClass]="{ 'transparent-background': transparentBackground }">
      <div id="footer" class="p-grid">
        @if (!appOnlyHasMovies) {
          <div class="footer-logo" [class.footer-logos]="mutiplelogos">
            <ng-container *ngIf="!mutiplelogos; else mutiplelogosTemplate">
              @if (omitLogoLink) {
                <ng-container *ngTemplateOutlet="logoImg"></ng-container>
              } @else {
                <a *ngIf="!logoLinkExternal" [routerLink]="logoLink" class="nav-logo nav-link">
                  @if (logoUrl?.indexOf('/assets/') !== 0) {
                    <ng-container *ngTemplateOutlet="logoImg"></ng-container>
                  } @else {
                    <ng-container *ngTemplateOutlet="assetImg"></ng-container>
                  }
                </a>
                <a *ngIf="logoLinkExternal" [href]="logoLink" class="nav-logo nav-link">
                  <ng-container *ngTemplateOutlet="logoImg"></ng-container>
                </a>
              }

              <ng-template #assetImg>
                <img [src]="logoUrl" alt="logo" class="footer-icon" />
              </ng-template>
              <ng-template #logoImg>
                <img [src]="logoUrl | img: logoParams" alt="logo" class="footer-icon" [ngClass]="logoClass" />
              </ng-template>
            </ng-container>

            <ng-template #mutiplelogosTemplate>
              <span [attr.data-translate]="multiplelogosText">{{ multiplelogosText }}</span>

              <ng-container *ngFor="let logo of mutiplelogos">
                <a
                  class="nav-logo nav-link"
                  *ngIf="!logo?.logoLinkExternal"
                  [routerLink]="logo?.logoLink"
                  [ngClass]="logo?.logoClass"
                >
                  <img
                    class="footer-icon"
                    *ngIf="logo?.logoUrl?.indexOf('/assets/') !== 0; else logoAssetImg"
                    [src]="logo?.logoUrl | img: logo?.logoParams"
                    alt="{{ logo?.logoAlt ? logo?.logoAlt : 'logo ' + logo?.logoClass }}"
                  />
                </a>
                <a
                  class="nav-logo nav-link"
                  *ngIf="logo?.logoLinkExternal"
                  [href]="logo?.logoLink"
                  [ngClass]="logo?.logoClass"
                >
                  <img
                    class="footer-icon"
                    *ngIf="logo?.logoUrl?.indexOf('/assets/') !== 0; else logoAssetImg"
                    [src]="logo?.logoUrl | img: logoParams"
                    alt="{{ logo?.logoAlt ? logo?.logoAlt : 'logo ' + logo?.logoClass }}"
                  />
                </a>

                <ng-template #logoAssetImg>
                  <img
                    class="footer-icon"
                    [src]="logo?.logoUrl"
                    alt="{{ logo?.logoAlt ? logo?.logoAlt : 'logo ' + logo?.logoClass }}"
                  />
                </ng-template>
              </ng-container>
            </ng-template>
          </div>
        }

        @if (hasSocialLinks && socialLinks?.length > 0) {
          <ush-social-links [socialNetworks]="socialLinks" />
        }

        <ng-container *ngIf="links?.length || 0 > 0">
          <div class="footer-menu-wrap">
            <ul class="footer-menu">
              <li *ngFor="let link of links" (click)="onFooterLinkClicked(link)">
                <ng-container [ngSwitch]="true">
                  <!-- External link -->
                  <a
                    *ngSwitchCase="link.isExternal"
                    [href]="link.link"
                    target="_blank"
                    class="nav-link bold"
                    [attr.data-external]="true"
                    [attr.data-translate]="'public.footer.link.' + (link.name | cammelCase)"
                  >
                    {{ link.name | cammelCase | footerLocalize: link.name }}
                    <div class="border"></div>
                  </a>

                  <a
                    *ngSwitchCase="!link.isExternal && !(link.isPopup && link.command)"
                    [routerLink]="link.url || link.link"
                    [fragment]="link.fragment"
                    class="nav-link bold"
                    [ngClass]="{ active: link.isActive, hasLink: link?.link, isParent: link?.isParent }"
                    [attr.data-translate]="'public.footer.link.' + (link.name | cammelCase)"
                  >
                    {{ link.name | cammelCase | footerLocalize: link.name }}
                    <div class="border"></div>
                  </a>
                  <!-- Popup (no routerLink) -->
                  <span
                    *ngSwitchDefault
                    class="nav-link bold"
                    [ngClass]="{ active: link.isActive, hasLink: link?.link, isParent: link?.isParent }"
                    [attr.data-translate]="'public.footer.link.' + (link.name | cammelCase)"
                  >
                    {{ link.name | cammelCase | footerLocalize: link.name }}
                    <div class="border"></div>
                  </span>
                </ng-container>
              </li>
              <!-- footer custom link -->
              <ng-container *ngIf="footerCustomLinkTemplate">
                <ng-container
                  [ngTemplateOutlet]="footerCustomLinkTemplate"
                  [ngTemplateOutletContext]="{ $implicit: footerInstance }"
                ></ng-container>
              </ng-container>
            </ul>
          </div>
        </ng-container>

        <ng-container *ngIf="copyrightMsg">
          <div class="copyright">
            {{ copyrightMsg }}
          </div>
        </ng-container>

        <ush-language-selector *ngIf="channelMultipleLanguages"></ush-language-selector>

        <!-- Footer custom module -->
        <ng-container *ngIf="footerComplementModuleContent as footerContent">
          <div class="foooter-custom-module" [innerHTML]="footerContent | safe: 'html'"></div>
        </ng-container>

        <!-- usheru logo -->
        <ush-usheru-logo
          [ngClass]="{
            'only-element':
              appOnlyHasMovies &&
              links.length <= 0 &&
              hasSocialLinks &&
              socialLinks?.length <= 0 &&
              !copyrightMsg &&
              !channelMultipleLanguages
          }"
        ></ush-usheru-logo>
        <!-- end usheru logo -->
      </div>
    </div>
  </ng-container>
</footer>
